import React, { useEffect, useState } from 'react';
import { Target, Save, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/drive-goal`;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('admin_token')}`, 'Content-Type': 'application/json' });

export const DriveGoalSettings = () => {
  const [g, setG] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { fetch(API, { headers: headers() }).then(r => r.json()).then(setG).catch(() => {}); }, []);
  if (!g) return null;

  const save = async () => {
    setBusy(true);
    const res = await fetch(API, { method: 'PUT', headers: headers(), body: JSON.stringify({ target: Number(g.target), deadline: g.deadline, offline_count: Number(g.offline_count) }) });
    const d = await res.json().catch(() => ({}));
    setBusy(false);
    if (res.ok) { setG(d); toast.success('Drive goal updated'); } else toast.error(typeof d.detail === 'string' ? d.detail : 'Check the values and try again');
  };

  const current = (Number(g.offline_count) || 0) + g.online_count;
  return (
    <Card className="mb-8" data-testid="drive-goal-settings">
      <CardHeader><CardTitle className="flex items-center gap-2"><Target className="h-5 w-5 text-party-red" /> Membership Drive Goal</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <div className="grid gap-4 sm:grid-cols-3">
          <div><Label>Goal (members)</Label><Input type="number" min="1" value={g.target} onChange={(e) => setG({ ...g, target: e.target.value })} className="mt-1" data-testid="goal-target-input" /></div>
          <div><Label>Deadline</Label><Input type="date" value={g.deadline} onChange={(e) => setG({ ...g, deadline: e.target.value })} className="mt-1" data-testid="goal-deadline-input" /></div>
          <div><Label>Offline / pre-drive count</Label><Input type="number" min="0" value={g.offline_count} onChange={(e) => setG({ ...g, offline_count: e.target.value })} className="mt-1" data-testid="goal-offline-input" /></div>
        </div>
        <p className="text-sm text-gray-600" data-testid="goal-preview">
          Homepage shows <b>{current.toLocaleString('en-US')}</b> / {Number(g.target || 0).toLocaleString('en-US')} = {g.offline_count || 0} offline + <b>{g.online_count}</b> online sign-ups (online count updates automatically).
        </p>
        <Button onClick={save} disabled={busy} className="bg-party-green hover:bg-green-700" data-testid="goal-save-btn">
          {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Save className="mr-2 h-4 w-4" />} Save goal
        </Button>
      </CardContent>
    </Card>
  );
};
